import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import UptimeHeatmap from '~/javascript/components/admin/uptime/UptimeHeatmap.vue'

/**
 * Dashboard Uptime Heatmap Controller
 *
 * Customer-facing version that uses ajax endpoints instead of admin endpoints.
 * Mounts the same Vue UptimeHeatmap component.
 */
export default class extends Controller {
  static targets = ['container']

  static values = {
    websiteId: String,
    days: { type: Number, default: 30 }
  }

  connect() {
    console.log('[Dashboard:UptimeHeatmap] Connected for website:', this.websiteIdValue)
    this.mountVueComponent()
  }

  disconnect() {
    if (this.vueApp) {
      this.vueApp.unmount()
      this.vueApp = null
    }
  }

  mountVueComponent() {
    // Clear placeholder content
    this.element.innerHTML = ''

    // Mount Vue app using ajax endpoint instead of admin endpoint
    this.vueApp = createApp(UptimeHeatmap, {
      websiteId: this.websiteIdValue,
      days: this.daysValue,
      apiUrl: `/ajax/uptime/${this.websiteIdValue}/heatmap`
    })

    // Mount to element
    this.vueApp.mount(this.element)
  }
}
